import React, { ReactElement, useEffect } from 'react';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import { useLocation, useParams } from 'react-router';
import routes from '../../../routing/routes';
import Layout from '../../Layout';
import useDetailTerminu from '../../../module/DetailTerminu/hook/useDetailTerminu';
import GlobalErrors from '../../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import SecuredPage from '../../../module/SecuredPage';
import UserRoleEnum from '../../../model/currentuser/UserRole';
import PoznamkaUpdate from '../../../module/Admin/Termin/PoznamkaUpdate';

const AdminTerminPoznamkaUpdatePage = (): ReactElement => {
  const { pathname } = useLocation();
  const {
    tezaurusUuid,
    terminUuid,
  } = useParams<{ tezaurusUuid: string, terminUuid: string }>();
  const {
    termin,
    terminStatus,
  } = useDetailTerminu(terminUuid, true);

  useEffect(() => {
    if (!terminStatus?.loading) {
      setTitle(getTitle());
    }
  }, [terminStatus.loading]);

  return (
    <Layout>
      <>
        <Breadcrumbs routeList={[
          homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
          {
            to: routes.tezaurus.admin.list,
            heading: 'Administrácia tezaurov',
          },
          {
            to: routes.tezaurus.admin.termin.list.withParams(tezaurusUuid),
            heading: termin?.tezaurus?.nazov || 'Zoznam termínov',
          },
          {
            to: routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid),
            heading: 'Úprava termínu',
          },
          {
            to: pathname,
            heading: 'Poznámky',
          },
        ]}
        />
        <GlobalErrors />
        <SecuredPage
          allowForRoles={[UserRoleEnum.ADMINISTRATOR_TEZAURUS, UserRoleEnum.REDAKTOR_TEZAURUS]}
          requestStatus={terminStatus?.responseCode}
        >
          <>
            <Loader loading={terminStatus?.loading}>
              {termin && (
                <>
                  <PageHeadingWithBackButton
                    heading={termin.preferovanyTermin}
                    headingCaption="Úprava termínu"
                  />
                  <PoznamkaUpdate
                    initialPoznamka={termin.poznamka}
                  />
                </>
              )}
            </Loader>
          </>
        </SecuredPage>
      </>
    </Layout>
  );
};
export default AdminTerminPoznamkaUpdatePage;
